import {DarkModeOutlined, LightModeOutlined} from '@mui/icons-material';
import {IconButton, useColorScheme} from '@mui/material';
import {LightTooltip} from '@ui/LightTooltip/LightTooltip';
import {useEffect} from 'react';
import {useTranslation} from 'react-i18next';
import {useUserSettings} from 'utils';
import {HeaderMenuItem} from './Menu/HeaderMenuItem';
import {useDeviceInfo} from 'utils/hooks/useDeviceInfo';

export const ColorModeToggle = () => {
    const {t} = useTranslation('header');
    const {settings: themeSettings, changeSettings} = useUserSettings('themeSettings');
    const {setMode, mode} = useColorScheme();
    const {isMobile} = useDeviceInfo();

    useEffect(() => {
        if (!themeSettings) return;
        setMode(themeSettings.theme);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [themeSettings?.theme]);

    const handleColorModeChange = () => {
        const theme = mode === 'light' ? 'dark' : 'light';
        changeSettings({...themeSettings, theme});
    };

    const options = [
        {
            value: 'dark',
            label: t('darkTheme'),
        },
        {
            value: 'light',
            label: t('lightTheme'),
        },
    ];

    if (isMobile) {
        return (
            <>
                {options.map((option) => (
                    <HeaderMenuItem
                        key={option.value}
                        isActiveElement={mode === option.value}
                        onClick={handleColorModeChange}
                        title={
                            <>
                                {option.value === 'light' ? (
                                    <DarkModeOutlined />
                                ) : (
                                    <LightModeOutlined />
                                )}{' '}
                                {option.label}
                            </>
                        }
                    />
                ))}
            </>
        );
    }

    return (
        <LightTooltip title={mode === 'light' ? t('darkTheme') : t('lightTheme')}>
            <IconButton onClick={handleColorModeChange}>
                {mode === 'light' ? <DarkModeOutlined /> : <LightModeOutlined />}
            </IconButton>
        </LightTooltip>
    );
};
